<!-- 
Signs the user out then returns to the sign in page.
We do it this way because signing out without moving off a page
containing components will make all the components try
to reload themselves - which will cause errors because the user is no longer signed in.
-->
<template>
  <div>
    <strong>Signing out, please wait...</strong>
  </div>
</template>

<script>
import * as action from "@/store/users/action-types";

export default {
  name: "SignOutRedirect",
  mounted() {
    this.signOut();
  },
  methods: {
    async signOut() {
      await this.$store.dispatch(action.SIGN_OUT);
      this.$router.push("/sign-in");
    }
  }
};
</script>
